
export const modalPicture = {
  applyNow: {
    desktop: "https://static.amityonline.com/_s/home_popup_259dd96383.webp",
    mobile: "https://amityonline.com/_s/home_popup_desktop_ec2411fddf.webp",
  },
  enquiryNow: {
    desktop: "https://amityonline.com/_s/Web_banners_ff9c85f386.webp",
    mobile: "https://amityonline.com/_s/Mobile_banners_2_72532d3f84.webp",
  },
};
